function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import './text.scss';
export var Heading = function (_ref) {
  var children = _ref.children,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    element = _ref.element,
    other = _objectWithoutProperties(_ref, ["children", "text", "className", "element"]);
  var Element = element || 'h3';
  var innerText = children || text;
  try {
    innerText = decodeURI(innerText);
  } catch (e) {
    innerText = innerText || '';
  }
  return /*#__PURE__*/React.createElement(Element, {
    className: "t-heading ".concat(className),
    dangerouslySetInnerHTML: {
      __html: innerText
    }
  });
};
export var Preface = function (_ref2) {
  var children = _ref2.children,
    _ref2$text = _ref2.text,
    text = _ref2$text === void 0 ? '' : _ref2$text,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    other = _objectWithoutProperties(_ref2, ["children", "text", "className"]);
  var innerText = children || text;
  try {
    innerText = decodeURI(innerText);
  } catch (e) {
    innerText = innerText || '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "t-preface ".concat(className),
    dangerouslySetInnerHTML: {
      __html: innerText
    }
  });
};
export var Body = function (_ref3) {
  var children = _ref3.children,
    _ref3$text = _ref3.text,
    text = _ref3$text === void 0 ? '' : _ref3$text,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    other = _objectWithoutProperties(_ref3, ["children", "text", "className"]);
  var innerText = children || text;
  try {
    innerText = decodeURI(innerText);
  } catch (e) {
    innerText = innerText || '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "t-body ".concat(className),
    dangerouslySetInnerHTML: {
      __html: innerText
    }
  });
};
export var Timestamp = function (_ref4) {
  var _ref4$text = _ref4.text,
    text = _ref4$text === void 0 ? '' : _ref4$text,
    children = _ref4.children,
    _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? '' : _ref4$className,
    other = _objectWithoutProperties(_ref4, ["text", "children", "className"]);
  var innerText = children || text;
  try {
    innerText = decodeURI(innerText);
  } catch (e) {
    innerText = innerText || '';
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "t-timestamp ".concat(className),
    dangerouslySetInnerHTML: {
      __html: innerText
    }
  });
};

// TODO: Se om caption skal brukes eller ikke. Mulig endre på standardtekst
export var Caption = function (_ref5) {
  var _ref5$text = _ref5.text,
    text = _ref5$text === void 0 ? '' : _ref5$text,
    children = _ref5.children,
    _ref5$className = _ref5.className,
    className = _ref5$className === void 0 ? '' : _ref5$className,
    other = _objectWithoutProperties(_ref5, ["text", "children", "className"]);
  var innerText = children || text || "Foto: TINE SA";
  return /*#__PURE__*/React.createElement("span", {
    className: "t-caption ".concat(className),
    dangerouslySetInnerHTML: {
      __html: innerText
    }
  });
};